import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';

export type TabOption = {
    key: string;
    tabName: string;
    selected: boolean;
}

@customElement('ji-tab-element')
export class JobindsatsTabElement extends JobindsatsElement(LitElement) {
    static styles = css`
        .tab-bar {
            display: flex;
            align-items: flex-end;
            margin-block: 0;
            border:inherit;
            padding: inherit;
            margin: inherit;
        }
        .tab[aria-selected="true"] {
            font-weight: bold;
        }
        .tab[aria-selected="true"]::after {
              border-bottom: 6px solid var(--main-blue);
        }
        .tab {
            white-space: nowrap;
            cursor: pointer;
            font-family: var(--font-family);
            background: none;
            border: none;
            padding: 5px 32px;
            padding-left: 26px;
            padding-bottom: 0px;
            padding-top: 15px;
            position: relative;
            flex: 0 1 0px;
            font-size: inherit;
        }
        .tab:hover {
            color: var(--main-blue);
            font-weight: bold;
        }
        .tab::after {
            border-bottom: 6px solid transparent;
            content: '';
            display: block;
            height: 100%;
            width: 100%;
            padding-bottom: 6px;
        }
        .databank-selection {
            border-bottom: thin solid var(--main-blue-25);
            margin: 24px 30px 0px;
        }
        .databank-tab {
            padding-left: 10px;
            padding-right: 10px;
            margin-right: 25px;
            margin-left: -10px;
            bottom: -1px;
        }
    `;

    @property({
        attribute: 'options',
    })
    options: TabOption[] = [];

    @property()
    databank = false;

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    render() {
        return html`
            <div class="tab-bar ${this.databank ? 'databank-selection' : ''}" role="tablist">
                ${this.options.map(option => html`
                    <button class="tab ${this.databank ? 'databank-tab' : ''}" role="tab" aria-selected=${option.selected ? 'true' : 'false'} @click=${() => this.tabSelected(option.key)}>${option.tabName}</button>
                `)}
            </div>
        `;
    }

    tabSelected(optionKey: string) {
        const tabSelectedEvent = new CustomEvent('tab-selected', {
            detail: {
                key: optionKey,
            },
            composed: true,
            bubbles: true,
        });
        this.dispatchEvent(tabSelectedEvent);
    }
}